import { useState, useEffect, useRef, useContext } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { motion, AnimatePresence } from 'framer-motion'
import {
    generateFromKnowledge,
    saveQuestions,
    updateQuestions,
    getLessonName,
    fetchExamBank,
    uploadKnowledgeText,
    deleteQuestions
} from '@/api/kuizy'
import KnowledgeUploader from '@/widgets/KnowledgeUploader'
import CommonSettings from '@/widgets/CommonSettings'
import ManualQuestionForm from '@/widgets/ManualQuestionForm'
import QuestionsCard from '@/widgets/QuestionsCard'
import ConfirmModal from '@/widgets/ConfirmModal'
import {
    levelMapping,
    examTypeMapping,
    typeSummaryMapping,
    LANGUAGES_AI,
    localeToLabel,
    browserLocale
} from '@/settings/master'
import {
    Trash2,
    ArrowLeft,
    BookOpen,
    Wand2,
    ListChecks,
    Redo2,
    Plus,
    Loader2,
    Mountain,
    MessageCircleMore,
    MessageCircleQuestion,
    Layers3,
    ChevronRight,
    List as ListIcon,
    AlertTriangle,
    Brain,
} from 'lucide-react'
import { LayoutContext } from "../layout/KuizyLayout";
import ImportExamModal from '../widgets/ImportExamModal'


export default function UploadContentPage() {
    const { cid: cidRaw, lid: lidRaw } = useParams()
    const nav = useNavigate()
    const cid = decodeURIComponent(cidRaw || '')
    const lid = lidRaw ? decodeURIComponent(lidRaw) : ''
    const uid = localStorage.getItem('userId') || '1'

    const uploaderRef = useRef(null)
    const [uploadBusy, setUploadBusy] = useState(false)
    const [unsumCount, setUnsumCount] = useState(0)
    const [sumStats, setSumStats] = useState({ total: 0, summarized: 0, unsummarized: 0, tokens: 0 })
    const [showSummaryGate, setShowSummaryGate] = useState(false)
    return (
        <>
            <KnowledgeUploader
                ref={uploaderRef}
                examId={lid}
                onUploaded={() => { }}
                onBusyChange={setUploadBusy}
                onSummaryStats={s => { setSumStats(s); setUnsumCount(s.unsummarized) }}
            />
        </>
    )
}
